import styled from "styled-components";

export const PanelHeader = styled.div`
  background-color: #56666c;
  padding: 1em;
  border-top-left-radius: 0.286em;
  border-top-right-radius: 0.286em;
  color: white;
  font-family: Lato;
  font-weight: 700;
  cursor: pointer;
`;

export const PanelBody = styled.div`
  padding: ${({ padding }) => padding || ".6em 1em"};
  background-color: white;
  border-bottom-left-radius: 0.286em;
  border-bottom-right-radius: 0.286em;
  max-height: 28.571em;
  overflow: scroll;
`;

export const Panel = styled.div`
  background-color: white;
  border-radius: 0.286em;
  box-shadow: 0 1px 5px 0 rgba(86, 102, 108, 0.24);
  overflow: hidden;
  margin: ${({ margin }) => margin || "0"};
  hr {
    margin: 0;
    border-width: 0.061em;
    border-color: #b8c4c9;
  }
`;

export default Panel;
